import objectHelper from "@/classes/helpers/objectHelper";
import * as COTISATIONS from "@/classes/parametrage/cotisations";

export default {
  /*
   * Récupération du paramétrage des garanties correspondant à la tranche d'âge et au type de garantie
   */
  getTauxCotisations(idGarantie) {
    var result = 0;

    var parametrages = COTISATIONS.PARAMETRAGE.filter((x) => x.idGarantie == idGarantie);
    if (objectHelper.arrayIsNotEmpty(parametrages)) {
      result = parametrages.find((x) => x.idGarantie == idGarantie).taux;
    }

    // Le taux est un pourcentage
    result = result / 100;

    return result;
  },
};
